import { render } from "./sendButton.vue?vue&type=template&id=65818993&scoped=true"
import script from "./sendButton.vue?vue&type=script&lang=js"
export * from "./sendButton.vue?vue&type=script&lang=js"

import "./sendButton.vue?vue&type=style&index=0&id=65818993&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65818993"]])

export default __exports__